




















































































































































































import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import BusinessDashboardBooking from './Dashboard/BusinessDashboardBooking.vue';
import { showWelcomeInstruction } from '@/utils/business';

@Component({
  components: {
    BusinessDashboardBooking,
  },
  computed: {
    ...mapState({
      showAlert: 'showAlert',
    }),
    ...mapState('Auth', {
      activeBusiness: 'activeBusiness',
    }),
    ...mapState('Booking', {
      bookings: 'list',
    }),
  },
  methods: {
    showWelcomeInstruction,
  },
})
export default class BusinessDashboard extends Vue {
  activeBusiness!: Model;

  isMounted = false;

  created() {
    this.$store
      .dispatch('Booking/fetchList', {
        params: {
          business_oid: this.activeBusiness.object_id,
          sort: '-created_at',
          expand: [
            'booking_candidates',
            'risk_profile',
            'booking_candidates.questionnaire_answer.recommendation',
          ],
          per_page: 10,
        },
      })
      .then(() => {
        this.isMounted = true;

        // Only show instruction if the route is business-dashboard, this is to prevent showing instruction
        // when the API request finished but the route has been changed
        if (
          !localStorage.getItem('step_by_step_guides') &&
          this.$route.name === 'business-dashboard'
        ) {
          showWelcomeInstruction(this.$tours);
        }
      });
  }

  hideAlert() {
    this.$store.commit('SET_SHOW_ALERT', false);
  }
}
